import { CheckCircle } from "@phosphor-icons/react";

const TZ = "America/Denver";
const fmtTime = (d) => d.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit", timeZone: TZ });
const weekday = (iso) => (iso ? new Date(iso).toLocaleDateString("en-US", { weekday: "long", timeZone: TZ }) : "");
const Btn = ({ onClick, children, testid }) => (
  <button onClick={onClick} data-testid={testid}
    className="font-semibold text-foreground hover:text-[hsl(var(--accent))] underline decoration-dotted underline-offset-2 transition-colors">
    {children}
  </button>
);

// Bite 4.5 status strip — four variants driven by previous_visit_at + changes_since.
export const StatusStrip = ({ previousVisitAt, changesSince, needsYou, onNeedsYou, onChanges }) => {
  const now = new Date();
  const changesTotal = changesSince
    ? Object.entries(changesSince).filter(([k]) => k !== "since").reduce((s, [, v]) => s + (v || 0), 0)
    : 0;
  const prev = previousVisitAt ? new Date(previousVisitAt) : null;
  const minsAgo = prev ? (now - prev) / 60000 : null;

  const wrap = (children, testid = "status-strip") => (
    <div data-testid={testid}
      className="bg-muted/50 border border-border rounded-lg px-4 py-2.5 text-sm text-muted-foreground flex flex-wrap items-center gap-x-2 gap-y-1">
      {children}
    </div>
  );

  // First visit ever
  if (!prev) {
    return wrap(<span data-testid="strip-first-visit">Welcome — this is your first visit to the morning check.</span>);
  }
  // Recent re-visit (< 1 hour)
  if (minsAgo < 60) {
    return wrap(<span data-testid="strip-recent">Refreshed since {fmtTime(prev)}. No new activity in the last hour.</span>);
  }
  const daysAway = Math.floor(minsAgo / 1440);
  const needsYouEl = needsYou === 0
    ? <span className="inline-flex items-center gap-1 text-[hsl(var(--success))] font-semibold"><CheckCircle size={15} weight="fill" />0 items need you</span>
    : <Btn onClick={onNeedsYou} testid="strip-needs-you">{needsYou} items need you</Btn>;
  const changesEl = <Btn onClick={onChanges} testid="strip-changes">{changesTotal} changes since your last visit ({weekday(previousVisitAt)})</Btn>;

  // Long-away (> 7 days)
  if (daysAway > 7) {
    return wrap(<><span data-testid="strip-long-away">Welcome back — you've been away {daysAway} days. </span>{changesEl}</>);
  }
  // Returning visit (1h – 7d)
  return wrap(<>
    <span>As of {fmtTime(now)} ET</span><span>·</span>{needsYouEl}<span>·</span>{changesEl}
  </>);
};
